import { useEffect, useState } from "react"

const TABLET_MIN_WIDTH = 768
const TABLET_MAX_WIDTH = 1024

export const useIsTablet = () => {
  const [isTablet, setIsTablet] = useState(false)

  useEffect(() => {
    const updateIsTablet = () => {
      if (typeof window === "undefined") return
      setIsTablet(
        window.innerWidth >= TABLET_MIN_WIDTH &&
          window.innerWidth <= TABLET_MAX_WIDTH
      )
    }

    updateIsTablet()
    window.addEventListener("resize", updateIsTablet)

    return () => window.removeEventListener("resize", updateIsTablet)
  }, [])

  return isTablet
}
